import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      venues: 'popular/getPopularVenues',
      cities: 'popular/getPopularCities',
      genres: 'popular/getPopularGenres'
    }),
    menuItems () {
      return [
        {
          list: this.firstLevelCategories,
          category: this.$t('Category'),
          rows: 3
        },
        {
          list: this.genres,
          category: this.$t('Genre')
        },
        {
          list: this.cities,
          category: this.$t('Cities')
        },
        {
          list: this.venues,
          category: this.$t('Venues')
        },
        {
          list: this.getMonths,
          category: this.$t('Date')
        }
      ]
    },
    // getCategories holds ~1200 reactive categories. Read other computeds once, outside the
    // loops: reading a computed inside a callback re-registers all of its dependencies per item.
    firstLevelCategories () {
      const typeCategory = this.getTypeCategory
      if (!typeCategory) return []

      return this.getCategories.filter(c => c.parent_id === typeCategory.id)
    },
    getAllCategory () {
      return this.getCategories.find(c => c.name === 'Alla Evenemang')
    },
    getTypeCategory () {
      return this.getCategories.find(c => c.name === 'Kategorier')
    },
    getPeriodCategory () {
      return this.getCategories.find(c => c.name === 'Datum')
    },
    getMonths () {
      const periodCategory = this.getPeriodCategory
      if (!periodCategory) return []

      return this.getCategories
        .filter(c => c.parent_id === periodCategory.id)
        .sort((a, b) => a.id - b.id)
    }
  },
  mounted () {
    this.$store.dispatch('popular/loadPopularVenues')
    this.$store.dispatch('popular/loadPopularCities')
    this.$store.dispatch('popular/loadPopularGenres')
  }
}
